import './style.css';
import { Id, toast, TypeOptions } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const NotifyUpdate = (msg: any, type: TypeOptions, id: Id) => {
  toast.update(id, {
    render: getNotificationRender(msg, type),
    type: `${type}`,
    className: 'default-toast-oq-pwa',
    hideProgressBar: false,
    pauseOnHover: true,
  });
};

function getNotificationRender(msg: string, type: string) {
  switch (type) {
    case 'success':
      return (
        <div>
          <i
            className="fa fa-2x fa-padding-right-2 fa-check-circle-o faa-pulse animated"
            aria-hidden="true"
          />
          <span>{msg}</span>
        </div>
      );
    case 'info':
      return (
        <div>
          <i
            className="fa fa-2x fa-padding-right-2 fa-info faa-ring animated"
            aria-hidden="true"
          />
          <span>{msg}</span>
        </div>
      );
    case 'warn':
      return (
        <div>
          <i
            className="fa fa-2x fa-padding-right-2 fa-exclamation-triangle faa-horizontal animated"
            aria-hidden="true"
          />
          <span>{msg}</span>
        </div>
      );
    case 'error':
      return (
        <div>
          <i
            className="fa fa-2x fa-padding-right-2 fa-times faa-tada animated"
            aria-hidden="true"
          />
          <span>{msg}</span>
        </div>
      );
    case 'info_sad':
      return (
        <div>
          <i
            className="fa fa-2x fa-padding-right-2 fa-frown-o"
            aria-hidden="true"
          />
          <span>{msg}</span>
        </div>
      );
    case 'success_smile':
      return (
        <div>
          <i
            className="fa fa-2x fa-padding-right-2 fa-smile-o"
            aria-hidden="true"
          />
          <span>{msg}</span>
        </div>
      );
    case 'loading':
      return (
        <div>
          <i
            className="fa-2x fa-padding-right-2 fa fa-circle-o-notch fa-spin"
            aria-hidden="true"
          />
          <span>{msg}</span>
        </div>
      );
    default:
      return (
        <div>
          <i
            className="fa fa-2x fa-padding-right-2 fa-comment-o"
            aria-hidden="true"
          />
          <span>{msg}</span>
        </div>
      );
  }
}

export const Notify = (msg: string, type: string, autoClose = 5000) => {
  switch (type) {
    case 'success':
      return toast.success(
        <>
          <span>{msg}</span>
        </>,
        {
          className: 'default-toast-oq-pwa',
          autoClose: autoClose,
          hideProgressBar: false,
        }
      );
    case 'info':
      return toast.info(
        <>
          <span>{msg}</span>
        </>,
        {
          className: 'default-toast-oq-pwa',
          autoClose: autoClose,
          hideProgressBar: false,
        }
      );
    case 'warn':
      return toast.warn(
        <>
          <span>{msg}</span>
        </>,
        {
          className: 'default-toast-oq-pwa',
          autoClose: autoClose,
          hideProgressBar: false,
        }
      );
    case 'error':
      return toast.error(
        <>
          <span>{msg}</span>
        </>,
        {
          className: 'default-toast-oq-pwa',
          autoClose: autoClose,
          hideProgressBar: false,
        }
      );
    case 'info_sad':
      return toast.info(
        <>
          <span>{msg}</span>
        </>,
        {
          className: 'default-toast-oq-pwa',
          autoClose: autoClose,
          hideProgressBar: false,
        }
      );
    case 'success_smile':
      return toast.success(
        <>
          <span>{msg}</span>
        </>,
        {
          className: 'default-toast-oq-pwa',
          autoClose: autoClose,
          hideProgressBar: false,
        }
      );
    case 'loading':
      return toast.info(
        <>
          <span>{msg}</span>
        </>,
        {
          className: 'default-toast-oq-pwa',
          autoClose: autoClose,
          hideProgressBar: false,
        }
      );
    default:
      return toast(
        <>
          <span>{msg}</span>
        </>,
        {
          className: 'default-toast-oq-pwa',
          autoClose: autoClose,
          hideProgressBar: false,
          pauseOnHover: true,
        }
      );
  }
};
